function scrollDown(){

}
// Func = limiting Scope for this file
(function(){

	//full navigation
	const fullnav = document.querySelector('.full-top-nav');
	const primaryNav = {
		navOpen: document.querySelector('.menu-icon-holder'),
		navClose: document.querySelector('.close-nav-js')
	};

	if(fullnav) {
		primaryNav.navOpen.addEventListener('click', function () {
			fullnav.classList.add('expanded');
			document.querySelector('.booking-trig-js').classList.add('white-trigger');
		});
		primaryNav.navClose.addEventListener('click', function () {
			fullnav.classList.remove('expanded');
			document.querySelector('.booking-trig-js').classList.remove('white-trigger');
		});
	}

	const linkspectial = document.querySelectorAll('.link-special');

	linkspectial.forEach(element => {
		element.addEventListener('click', function () {
			fullnav.classList.remove('expanded');
			document.querySelector('.booking-trig-js').classList.remove('white-trigger');
		});
	});

	if(document.URL.indexOf( "#club-intercontinental" ) != -1){
		const navmenu = document.querySelectorAll(".privary-navigation .privary-navigation__item a.active")
		const linkactive = document.querySelectorAll(".privary-navigation .privary-navigation__item a.link-special")
		navmenu.forEach(element => {
			element.classList.remove('active');
		});

		linkactive.forEach(element => {
			element.classList.add('active');
		});
	}


	const bookingHolder = document.querySelector('.booking-holder') || [];
	const bookingNav = {
		bookingOpen: document.querySelector('.booking-trig-js'),
		bookingClose: document.querySelector('.close-booking-js')
	};

	if(bookingHolder) {
		bookingNav.bookingOpen.addEventListener('click', function () {
			bookingHolder.classList.add('expanded');
			document.querySelector('.booking-trig-js').classList.add('hide-trigger');
		});
		bookingNav.bookingClose.addEventListener('click', function () {
			bookingHolder.classList.remove('expanded');
			document.querySelector('.booking-trig-js').classList.remove('hide-trigger');
		});
	}


	//tabs sections
	const tabLinks = document.querySelectorAll('ul.tabs-menu li a');

	for (let i = 0; i < tabLinks.length; i++) {
		tabLinks[i].onclick = function() {
			let target = this.getAttribute('href').replace('#', '');
			let sections = document.querySelectorAll('div.tab-content');
			for(let j=0; j < sections.length; j++) {
				sections[j].style.display = 'none';
			}
			document.getElementById(target).style.display = 'block';
			for(let k=0; k < tabLinks.length; k++) {
				tabLinks[k].removeAttribute('class');
			}
			this.setAttribute('class', 'active');
			return false;
		}
	}

	//animations below
    const animateHTML = function () {
        let elems,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        };
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            }
        };
        return {
            init: init
        }
    };
    animateHTML().init();
    //end animations

	function resizeWindow(){
		setTimeout(function() {
			equalize();
			if($( document ).width() < 1025 ){
				// $("#header .full-top-nav #primary-nav ul li a").hover(function(){
				// 	$('this').trigger('click'); 
				// 	// $(this).click();
				// 	console.log('hola',$(this))
				// });
				// $('#header .full-top-nav #primary-nav ul li a').unbind();
				// $( "a" ).each(function( index ) {
				// 	// console.log( index + ": " + $( this ).text() );
				// 	$(this).off('hover');
				// });
			}
		}, 500);
	}

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (e) {
			resizeWindow();
		});
		resizeWindow();

        //homepage hero intro
        setTimeout(function(){
            $('body').addClass('loaded');
        }, 2000);


		$('#amenityMenu dl dt a#performing-arts').html('Arts & Culture');
		$('#amenityMenu dl dt a#museums').html('History & Museums');
		$('#amenityMenu dl dt a#shopping').html('Neighborhoods & Shopping');

		$('.media-inquiry-btn').click(function(){
			if (!$('#media-inquiry').hasClass('active')) {
				$('#media-inquiry').fadeToggle().toggleClass('active');
			} 
			$('html, body').animate({ scrollTop: $("#media-inquiry").offset().top - $('header').height() }, 500, 'linear');
        });
        $('.close-media-form').click(function(){
			$('#media-inquiry').fadeOut().toggleClass('active');;
        });

		function fillStartDateDropdowns(date_m_d_yy) {

			var strFilled;
			strFilled = date_m_d_yy.split("/");

			$(".startmonth").val((strFilled[0]-1)+strFilled[2]);  //put values
			$(".startday").val(strFilled[1]);
		}
		function fillEndDateDropdowns(date_m_d_yy) {

			var strFilled;
			strFilled = date_m_d_yy.split("/");

			$(".endmonth").val((strFilled[0]-1)+strFilled[2]);   //put values
			$(".endday").val(strFilled[1]);
		}

		$('.sub-menu ul').css({'--offset': $('#header').height() + 'px'});

		//Acts when scroll down page.
        $(window).scroll(function (event) {
            scrollDown();
            var top = ($('.int-top-section').height());
            if ($(this).scrollTop() > top) {
                $('.sub-menu ul').addClass('navbar-fixed');
                $('.int-top-section').addClass('scroll', 200);
            } else {
                $('.sub-menu ul').removeClass('navbar-fixed');
                $('.int-top-section').removeClass('scroll', 200);
            }
        });

		//Check in and check out datepicker for booking engine
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );

				fillStartDateDropdowns($(this).val());
				fillEndDateDropdowns($('#CheckOut').val());
			}
		});

		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
				fillEndDateDropdowns($(this).val());
			}
		});

		//On submit
		$('#booking-form').submit(function(){

		});

		//home slider animation
		if($('body#home').length > 0){
			setTimeout(function(){
				home()
			}, 1000)
		}

		$('#transportation').text("Tours & Transportation");
		$(".floorplan-video").on('click', function(event) {
		    event.preventDefault(); 
		    $.fancybox({
		        'type' : 'iframe',
		        // hide the related video suggestions and autoplay the video
		        'href' : this.href.replace(new RegExp('watch\\?v=', 'i'), 'embed/') + '?rel=0&autoplay=1',
		        'overlayShow' : true,
		        'centerOnScroll' : true,
		        'speedIn' : 100,
		        'speedOut' : 50,
		        'allowfullscreen':true,
		        'width'         : '100%',
				'height'        : '100%',
				'autosize': false,
				'iframe' : {
					preload: false
				}
		    });
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		$('body#map-category #content').prepend('<a class="btn return-from-map" href="/ada-map">ADA Map</a>');

		//Update HTML
		$("#footer").html(function(buscayreemplaza, reemplaza) {
		    return reemplaza.replace('<nav id="secondary-nav" class="secondary-navigation" role="navigation" aria-label="Secondary">', '<nav id="secondary-nav-footer" class="secondary-navigation" role="navigation" aria-label="Secondary-nav-footer">');
		});

		//Remove Attribute
		$('#third-nav').removeAttr('aria-labelledby');

		
	});

	$(window).on('load', function() {

		
	});


	// Func = Run only on homepage
	function home(){

		const mapItems = document.querySelectorAll('ul.js-mapPins > li');
		const mapContent = document.querySelectorAll('ul.js-mapMarkers > li');

		mapItems[1].classList.add('active');
		mapContent[1].classList.add('active');

		mapItems.forEach( e => {
			
			function map(ev){
				mapItems.forEach( a => a.classList.remove('active'));
				
				ev.target.classList.add('active');
				const pin = ev.target.dataset.pin;
				
				mapContent.forEach( t => {
					t.classList.remove('active');
					if (t.dataset.pin === pin)
						t.classList.add('active');
				});
			}
			e.addEventListener('click', debounce(map, 100));
		});

	}
	// Optimize: ensuring a given task doesn't fire so often
	function debounce(func, wait, immediate) {
		let timeout;
		return function() {
			const context = this, args = arguments;
			const later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			const callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	/* Trio Rotator Hover Functionality */

	let trioItem = document.getElementsByClassName('trio-rotator__each');

	if (trioItem) {
		for (let c = 0; c < trioItem.length; c++) {
			trioItem[c].addEventListener('mouseenter', function () {

				let inaciveItems = document.getElementsByClassName('trio-rotator__each');
				for (let x = 0; x < inaciveItems.length; x++) {
					inaciveItems[x].classList.add('noHover');
				};

				this.classList.remove('noHover');
				this.classList.add('hover');
			});
			trioItem[c].addEventListener('mouseleave', function () {
				let inaciveItems = document.getElementsByClassName('trio-rotator__each');
				for (let x = 0; x < inaciveItems.length; x++) {
					inaciveItems[x].classList.remove('noHover', 'hover');
				};
			});
		}
	}


}());